import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import library from "../../../assets/innovation/qrcode.png";

const ColorButton = styled(Button)(() => ({
  color: "#071783",
  width: 185,
  height: 55,
  fontWeight: 700,
  fontSize: "16px",
  textTransform: "capitalize",
  backgroundColor: "#F2C844",
  borderColor: "#F2C844",
  "&:hover": {
    color: "#071783",
    backgroundColor: "#fff",
    borderColor: "#fff",
  },
}));

const Incubation = () => {
  return (
    <Box>
      <Grid
        container
        display={"flex"}
        alignItems={"center"}
        margin={{ xs: "0%", sm: "5% 0%" }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          padding={{ xs: "25% 0% 25% 0%", sm: "0% 6% 3% 0%" }}
          marginBottom={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"h2"}
            fontWeight={400}
            textAlign={"left"}
            color={"#F2C844"}
            paddingBottom={{ xs: "0%", sm: "4%" }}
            fontFamily={"Kaushan Script"}
          >
            Register
          </Typography>
          <Typography
            variant={"h6"}
            fontWeight={700}
            textAlign={"left"}
            paddingTop={{ xs: "10%", sm: "0%" }}
            color={"#fff"}
            paddingBottom={"1%"}
          >
            Innovate Locally. Impact Globally.
          </Typography>
          <Box
            component="img"
            height={{ xs: "45vh", sm: "600px" }}
            width={{ xs: "100%", sm: "100%" }}
            display={{ xs: "block", sm: "none" }}
            marginTop={{ xs: "10%", sm: "0%" }}
            src={library}
            alt={"image"}
            sx={{
              objectFit: "cover",
            }}
          />

          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#fff"}
            padding={{ xs: "5% 0% 2% 0%", sm: "4% 0% 0% 0%" }}
            lineHeight={1.5}
          >
            Are you a student, entrepreneur, researcher, or developer with a
            bold idea that can solve real problems in Ogbomoso? The OORC
            Innovation Hub is your launchpad to turn concepts into impactful
            solutions. We’re looking for thinkers and doers ready to test,
            refine, and scale their innovations locally before going global.
            Through mentorship, collaboration, and technical incubation, we’ll
            help you bridge the gap between ideas and impact. Apply now and be
            part of a community where change begins at home. Scan the QR Code or
            click on the button below to register.
          </Typography>
          <Box marginTop={"4%"}>
            <ColorButton
              component={"a"}
              variant="contained"
              target="_blank"
              size="medium"
              href={"https://forms.gle/bfKYdXb8LN1jkQmB8"}
            >
              Register Now
            </ColorButton>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          margin={{ xs: "25% 0% 10% 0%", sm: "0%" }}
          display={{ xs: "none", sm: "block" }}
        >
          <Box
            component="img"
            height={{ xs: "45vh", sm: "600px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={library}
            alt={"image"}
            sx={{
              objectFit: "cover",
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Incubation;
